



















































import {
  defineComponent,
  computed,
  reactive,
  getCurrentInstance,
  ComponentInternalInstance,
  PropType,
  ref,
  watch,
} from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';

import { LoginMainEntrance, LoginTypeKey } from '@/renderer/scripts/utils/user/UserTyping';
import { IS_PRIVATE } from '@/common/constant';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';
import { User } from '@/renderer/scripts/utils/user';
import { LoginTypeKeyMap } from '@/renderer/scripts/utils/user/UserTypingMap';
import { i18n_t } from '@/locales/i18n';
import meeting from '@/renderer/scripts/utils/meeting';

import loginWithMeetingPhone from './loginWithMeetingPhone.vue';
import loginWithPhone from './loginWithPhone.vue';
import loginWithPassword from './loginWithPassword.vue';
// import loginWithApp from './loginWithApp.vue';
import loginWithWechat from './loginWithWechat.vue';
import loginWithJAccount from './loginWithJAccount.vue';
import loginWithIOA from './loginWithIOA.vue';

interface LoginRenderItem {
  icon: string;
  simpleTitle: string;
  title: string;
  value: string;
}
const LOGIN_MAIN_ENTRANCE_MAP: Record<LoginMainEntrance, LoginRenderItem> = {
  loginWithJAccount: {
    icon: 'login-with-other-icon',
    simpleTitle: 'jAccount',
    title: i18n_t('jAccount登录'),
    value: User.LoginTypeKey.loginWithJAccount,
  },
  loginWithIOA: {
    icon: 'login-with-other-icon',
    simpleTitle: 'IOA',
    title: i18n_t('iOA登录'),
    value: User.LoginTypeKey.loginWithIOA,
  },
  loginWithWechat: {
    icon: 'login-with-wechat-icon',
    simpleTitle: i18n_t('微信登录'),
    title: i18n_t('微信扫码登录'),
    value: User.LoginTypeKey.loginWithWechat,
  },
  loginWithPhone: {
    icon: 'login-with-phone-icon',
    simpleTitle: i18n_t('手机登录'),
    title: i18n_t('手机号登录'),
    value: User.LoginTypeKey.loginWithPhone,
  },
  loginWithPassword: {
    icon: 'login-with-password-icon',
    simpleTitle: i18n_t('账密登录'),
    title: i18n_t('账号密码登录'),
    value: User.LoginTypeKey.loginWithPassword,
  },
};

export interface MainEntranceComponent {
  radioGroupLoginType: LoginMainEntrance;
  renderLoginMainEntranceTabs: LoginRenderItem[];
  validate: () => boolean;
}

export default defineComponent({
  name: 'MainEntrance',
  components: {
    loginWithMeetingPhone,
    loginWithPhone,
    loginWithPassword,
    // loginWithApp,
    loginWithWechat,
    loginWithJAccount,
    loginWithIOA,
    ChevronLeftIcon,
  },
  props: {
    vistorLogin: {
      type: Boolean,
      default: false,
    },
    loginWay: {
      type: String as PropType<LoginTypeKey>,
      default: User.LoginTypeKey.loginWithPhone,
    },
    isOauth: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const vm = (getCurrentInstance() as ComponentInternalInstance).proxy;
    const store = vm.$store;

    // radioGroupLoginType只有2个值: loginWithPhone | loginWithWechat; 默认手机号登录
    const radioGroupLoginType = ref<LoginMainEntrance>(User.LoginTypeKey.loginWithPhone);

    const loginMainEntranceShow = reactive({
      loginWithIOA: false, // iOA登录
      loginWithJAccount: false, // 交大独有的jAccount登录
      loginWithWechat: false, // 微信扫码登录
      loginWithPhone: false, // 手机号登录
      loginWithPassword: false, // 账密登录（一般与手机号登录互斥）
    });
    const isCollectRoute = computed(() => vm.$route.name === 'collect');
    const isMobile = computed(() => {
      const { isMobile, isMobileStyle } = store.getters;
      return isMobile || isMobileStyle;
    });
    const loginAction = computed(() => store.getters.loginAction);
    const mainEntranceKeys = Object.keys(LOGIN_MAIN_ENTRANCE_MAP) as LoginTypeKey[];

    const isInMainEntrance = computed(() => {
      const isMainLoginWay = [...mainEntranceKeys, LoginTypeKey.loginWithMeetingPhone].includes(props.loginWay);
      const isBindingPhone = loginAction.value === User.LoginActionKey.bindPhone;
      return isMainLoginWay || isBindingPhone;
    });

    const renderLoginMainEntranceTabs = computed(() => {
      const isShareRoute = vm.$route.name === 'share';
      if (
        loginAction.value === User.LoginActionKey.bindPhone ||
        props.loginWay === User.LoginTypeKey.loginWithMeetingPhone ||
        store.getters.isInWeMeetApp ||
        (props.vistorLogin && !isShareRoute)
      )
        return [];
      // 公有云移动端界面不显示多入口
      if (!IS_PRIVATE && isMobile.value) return [];

      const tabs: LoginRenderItem[] = [];
      Object.keys(loginMainEntranceShow).forEach(key => {
        const type = key as LoginMainEntrance;
        const show = loginMainEntranceShow[type];
        if (show) {
          if (type === LoginTypeKey.loginWithWechat) {
            if (isMobile.value) return;
          }
          tabs.push(LOGIN_MAIN_ENTRANCE_MAP[type]);
        }
      });
      return tabs;
    });

    const renderLoginEntrance = computed(() => {
      const { loginWay, vistorLogin } = props;
      const showLoginWithPhoneInVisitor = loginWay === LoginTypeKey.loginWithPhone && vistorLogin;
      return {
        loginWithMeetingPhone: loginWay === LoginTypeKey.loginWithMeetingPhone && store.getters.isInWeMeetApp,
        loginWithPassword: loginWay === LoginTypeKey.loginWithPassword && loginMainEntranceShow.loginWithPassword,
        loginWithPhone:
          ((loginWay === LoginTypeKey.loginWithPhone || loginAction.value === User.LoginActionKey.bindPhone) &&
            loginMainEntranceShow.loginWithPhone &&
            radioGroupLoginType.value === LoginTypeKey.loginWithPhone) ||
          showLoginWithPhoneInVisitor,
        loginWithWechat: !isMobile.value && loginMainEntranceShow.loginWithWechat,
        loginWithJAccount: loginWay === LoginTypeKey.loginWithJAccount && loginMainEntranceShow.loginWithJAccount,
        loginWithIOA: loginWay === LoginTypeKey.loginWithIOA && loginMainEntranceShow.loginWithIOA,
      };
    });

    const hiddenWechatEntrance = computed(() => {
      return !isInMainEntrance || radioGroupLoginType.value !== LoginTypeKeyMap.loginWithWechat || props.vistorLogin;
    });

    const showTitle = ref(true);

    const methods = {
      initData() {
        if (IS_PRIVATE) {
          windowEnvs.loginMainEntrance.forEach(loginType => {
            loginMainEntranceShow[loginType] = true;
            if (loginType === LoginTypeKey.loginWithJAccount) {
              document.body.classList.add('sjtu');
            }
          });
        } else {
          Object.assign(loginMainEntranceShow, {
            loginWithWechat: true,
            loginWithPhone: true,
            loginWithPassword: false,
            loginWithJAccount: false,
            loginWithIOA: false,
          });
        }
        methods.initRadioGroupLoginType();
      },
      initRadioGroupLoginType() {
        if (meeting.isTMWebview) {
          radioGroupLoginType.value = User.LoginTypeKey.loginWithPhone;
        } else if (mainEntranceKeys.includes(props.loginWay)) {
          radioGroupLoginType.value = props.loginWay as LoginMainEntrance;
        } else {
          radioGroupLoginType.value = User.LoginTypeKey.loginWithPhone;
        }
      },
      validate() {
        const refMsg = `${props.loginWay}Ref`;
        const currRef = vm.$refs[refMsg];
        return (currRef as any)?.validate();
      },
      tiggerShowTitleInLoginWithPassword(show: boolean) {
        showTitle.value = show;
        if (show) {
          emit('cancel-reset-password');
        } else {
          emit('need-reset-password');
        }
      },
    };

    methods.initData();

    watch(
      () => store.getters.loginAction,
      val => {
        if (val === User.LoginActionKey.bindPhone) {
          radioGroupLoginType.value = User.LoginTypeKey.loginWithPhone;
        } else {
          methods.initRadioGroupLoginType();
        }
      },
    );

    return {
      showTitle,
      isCollectRoute,
      radioGroupLoginType,
      isInMainEntrance,
      LoginTypeKeyMap,
      loginMainEntranceShow,
      renderLoginEntrance,
      renderLoginMainEntranceTabs,
      hiddenWechatEntrance,
      ...methods,
    };
  },
});
